export default {
  setCustomers (state, customers) {
    state.items = customers
  },
}
